import { AppEventSdk } from '@sxm-de/dev-kits/web-sdk/types';
import { recordEddlUpdate } from './record-eddl-update';

export function trackUserEmail(appEventSdk: AppEventSdk, email: string) {
    recordEddlUpdate(appEventSdk, {
        customerInfo: {
            email,
        },
    });
}
